import { useMutation } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';

import { HolidayService } from './holidayService';
import { HolidayKey } from './keys';

const holidayIdSchema = z.number().int().positive();

export function useDeleteHoliday() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => HolidayService.deleteHoliday(holidayIdSchema.parse(id)).then((response) => response.data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [HolidayKey.HOLIDAYS] });
      void queryClient.invalidateQueries({
        queryKey: [HolidayKey.HOLIDAYS_INFINITE],
      });
    },
  });
}
